import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { DotsSixVerticalIcon } from '@phosphor-icons/react'

import RefundMethod from '../RefundMethod/RefundMethod'
import * as Styles from './styles'

const SortableRefundMethod = ({
  refundMethod,
  savedRefundMethod,
  isEditable,
  isSortable,
  isExpanded,
  onToggleExpanded,
  onChangeEnabled,
  currency,
  dragging,
  languages,
  subscriptionPlan,
  allowInstantTransactions,
  storeCurrencySymbol,
  provider,
  errors,
  onChange,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: refundMethod.id,
    disabled: !isSortable,
  })

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  }

  return (
    <Styles.SortableRefundMethodContainer ref={setNodeRef} style={style} isSortable={isSortable}>
      <DotsSixVerticalIcon
        dragging={dragging}
        {...attributes}
        {...listeners}
        size={24}
        id="draggable-icon"
        data-testid="draggable-icon"
      />
      <RefundMethod
        refundMethod={refundMethod}
        savedRefundMethod={savedRefundMethod}
        isEditable={isEditable}
        isExpanded={isExpanded}
        onToggleExpanded={onToggleExpanded}
        onChangeEnabled={onChangeEnabled}
        currency={currency}
        languages={languages}
        subscriptionPlan={subscriptionPlan}
        allowInstantTransactions={allowInstantTransactions}
        storeCurrencySymbol={storeCurrencySymbol}
        provider={provider}
        errors={errors}
        onChange={onChange}
      />
    </Styles.SortableRefundMethodContainer>
  )
}

export default SortableRefundMethod
